export const isWithinSixMonths = (currentWeek, getDateFromString) => {
    if (!currentWeek || !currentWeek.start || !currentWeek.end) {
        return false;
    }

    const currentWeekStartDate = getDateFromString(currentWeek.start);
    const currentWeekEndDate = getDateFromString(currentWeek.end);
    const today = new Date();
    const sixMonthsFromToday = new Date(today);
    sixMonthsFromToday.setMonth(today.getMonth() + 6);

    if (
        (currentWeekStartDate <= sixMonthsFromToday &&
            currentWeekEndDate >= sixMonthsFromToday) ||
        currentWeekStartDate > sixMonthsFromToday
    ) {
        return false;
    }
    return true;
};